import styled from 'styled-components'

export const StyledRoundPTooltip = styled.div`
  width: 575px;

  &.ant-tooltip-placement-topLeft .ant-tooltip-arrow {
    left: 20px;
  }

  &.ant-tooltip-hidden {
    display: none;
  }

  .ant-tooltip-inner {
    border-radius: 20px;
    position: absolute;
    bottom: 7px;
  }
  .ant-tooltip-arrow-content {
    width: 11px;
    height: 11px;
  }
  .popover-card {
    padding: 30px;
    text-align: left;
    .card-header {
      border-bottom: 0.5px solid #313755;
      padding-bottom: 15px;
    }
    .card-datetime {
      display: flex;
      justify-content: space-between;
    }
    dt {
      font-size: 13px;
      line-height: 20px;
      color: ${({ theme }) => theme.colors.textTertiary};
    }
    dd {
      font-weight: bold;
      font-size: 27px;
      color: #ffffff;
      margin: 0;
      white-space: nowrap;
    }
    .card-body {
      display: flex;
      flex-flow: row nowrap;
      padding-top: 15px;
      padding-bottom: 15px;
      & > div {
        flex: 1;
        border-right: 1px solid #313755;
        padding-right: 15px;
        margin-right: 15px;
        &:last-child {
          border: 0;
          margin-right: -30px;
          padding-right: 0;
        }

        dt.line2 {
          margin-top: 10px;
        }

        dd {
          font-size: 15px;
          color: #ffffff;

          &.highlight {
            font-weight: 500;
            font-size: 21px;
            color: ${({ theme }) => theme.colors.chartPurple};
          }
        }

        &:nth-child(2) {
          dd.highlight {
            color: #6daffc;
          }
        }
        &:nth-child(3) {
          dd.highlight {
            color: #4dd8d0;
          }
        }
      }

      &:last-child {
        border-top: 0.5px solid #313755;
        padding-bottom: 0;
      }
    }
  }

  @media screen and (max-width: 960px) {
    border-radius: 8px;
    padding-left: 20px;
    padding-right: 20px;
    .ant-tooltip-inner {
      width: calc(100vw - 20px);
      margin-left: -10px;
      border-radius: 8px;
      overflow-x: scroll;
    }
  }
`
